import { render, staticRenderFns } from "./link.vue?vue&type=template&id=09e93b0f&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"
import style0 from "./link.vue?vue&type=style&index=0&id=09e93b0f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e93b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e93b0f')) {
      api.createRecord('09e93b0f', component.options)
    } else {
      api.reload('09e93b0f', component.options)
    }
    module.hot.accept("./link.vue?vue&type=template&id=09e93b0f&scoped=true", function () {
      api.rerender('09e93b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/routerView/link.vue"
export default component.exports